import { ga4Track } from '@unisporkal/ga4';

const ga4EventFormat = (
  event,
  eventName,
  carouselInteraction,
  carouselSelection,
  uiElementLocation
) => ({
  event,
  event_name: eventName,
  carousel_interaction: carouselInteraction,
  carousel_selection: carouselSelection,
  ui_element_location: uiElementLocation,
});

/* Tracks the left/right navigation buttons on the side of carousel as well as swipe gesture */
export const navigationTrack = (direction) => {
  const uiElementLocation = `home_carousel_navigation_${direction}`;

  const ga4Event = ga4EventFormat(
    'carousel_interaction',
    `carousel_scroll_${direction}`,
    `carousel_scroll_${direction}`,
    `carousel_arrow_${direction}`,
    uiElementLocation
  );

  ga4Track(ga4Event);
};

/* Tracks clicks on the pagination dots at bottom of carousel */
export const paginationTrack = (direction) => {
  const uiElementLocation = 'home_carousel_pagination';

  const ga4Event = ga4EventFormat(
    'pagination_interaction',
    `pagination_scroll_${direction}`,
    `pagination_scroll_${direction}`,
    `pagination_dot_${direction}`,
    uiElementLocation
  );

  ga4Track(ga4Event);
};

/* Tracks clicks on slide CTA button */
export const ctaTrack = (tracking) => {
  const uiElementLocation = 'gi_home_carousel';

  const ga4Event = ga4EventFormat(
    'carousel_interaction',
    'carousel_item_click',
    'carousel_item_click',
    tracking,
    uiElementLocation
  );

  ga4Track(ga4Event);
};
